import PropTypes from 'prop-types'
import { useAuth } from 'providers'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to='/' replace state={{ from: location }} />
  }

  return children ? children : <Outlet />
}

ProtectedRoute.propTypes = {
  children: PropTypes.node,
}

export default ProtectedRoute
